import { httpService } from "../common/HttpService";

class SeasonsService {
  constructor() {}

  //getting weeks list
  getWeeksList(fkLeagueId, fkSeasonId) {
    return httpService.get(`seasons/${fkLeagueId}/${fkSeasonId}/weeks`);
  }
  //getting points table

  getPointsTable(fkLeagueId, seasonId) {
    return httpService.get(`/seasons/${fkLeagueId}/${seasonId}/pointstable`);
  }

}

export const seasonsService = new SeasonsService();

